import { render, staticRenderFns } from "./TutorialCard.vue?vue&type=template&id=5773179a&scoped=true"
import script from "./TutorialCard.vue?vue&type=script&lang=js"
export * from "./TutorialCard.vue?vue&type=script&lang=js"
import style0 from "./TutorialCard.vue?vue&type=style&index=0&id=5773179a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773179a",
  null
  
)

export default component.exports